export default __webpack_public_path__ + "images/DetallesLineasFactura-IT.png";